import {useEffect} from 'react';

import {BREAKPOINTS, MODULES_SIDEBAR_WIDTH} from '../../const';
import useBreakpoint from '../dom/useBreakpoint';
import useWindowSize from '../dom/useWindowSize';

const useReportContainerAutoResize = () => {
  const windowSize = useWindowSize();
  const currentBreakpoint = useBreakpoint();

  // This hook aims to constantly resize iframe container. This is kind of a hack to allow report to take full width
  // after performing a report.refresh(). Without this hook, there is a small lag and PBI wrongly calculates available width, causing report to be smaller than before refresh
  useEffect(() => {
    const interval = setInterval(() => {
      const iframe = document.querySelector('.report-hidden') ?? document.querySelector('.report-embed');

      if (iframe) {
        const sidebarWidth = currentBreakpoint === BREAKPOINTS.xs ? 0 : MODULES_SIDEBAR_WIDTH;
        const availableWidth = windowSize.width - sidebarWidth;
        const availableHeight = windowSize.height;
        iframe.style.width = `${availableWidth}px`;
        iframe.style.height = `${availableHeight - 64}px`;
      }
    }, 100);

    return () => clearInterval(interval);
  }, [windowSize]);
};

export default useReportContainerAutoResize;
